import LoadingPage from "components/LoadingPage";
import AdamicheModas from "pages/LojasVirtuais/AdamicheModas";
// import AdVox from "pages/LojasVirtuais/AdVox";
import SaborDosDeuses from "pages/LojasVirtuais/SaborDosDeuses";
import { lazy, Suspense } from "react";

const LojasVirtuais = lazy(() => import("pages/LojasVirtuais"));
const CamisetasMix = lazy(() => import("pages/LojasVirtuais/CamisetasMix"));
const ShopTecnologia = lazy(() => import("pages/LojasVirtuais/ShopTecnologia"));
const CasasPack = lazy(() => import("pages/LojasVirtuais/CasasPack"));
const BiancaFaust = lazy(() => import("pages/LojasVirtuais/BiancaFaust"));
const RizzyCollection = lazy(
  () => import("pages/LojasVirtuais/RizzyCollection"),
);
const RideTheBeat = lazy(() => import("pages/LojasVirtuais/RideTheBeat"));
const Javali40 = lazy(() => import("pages/LojasVirtuais/Javali40"));
const ViaDsSartoria = lazy(() => import("pages/LojasVirtuais/ViaDsSartoria"));
const Duotti = lazy(() => import("pages/LojasVirtuais/Duotti"));
const SaintLuce = lazy(() => import("pages/LojasVirtuais/SaintLuce"));

const useRoutersLojas = () => {
  return [
    {
      path: "/lojas-virtuais",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <LojasVirtuais />
        </Suspense>
      ),
    },
    {
      path: "/lojas-virtuais/camisetas-mix",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <CamisetasMix />
        </Suspense>
      ),
    },
    {
      path: "/lojas-virtuais/shop-tecnologia",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <ShopTecnologia />
        </Suspense>
      ),
    },
    {
      path: "/lojas-virtuais/adamiche-modas",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <AdamicheModas />
        </Suspense>
      ),
    },
    // {
    //   path: "/lojas-virtuais/advox",
    //   element: (
    //     <Suspense fallback={<LoadingPage />}>
    //       <AdVox />
    //     </Suspense>
    //   ),
    // },
    {
      path: "/lojas-virtuais/sabor-dos-deuses",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <SaborDosDeuses />
        </Suspense>
      ),
    },
    {
      path: "/lojas-virtuais/casas-pack",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <CasasPack />
        </Suspense>
      ),
    },
    {
      path: "/lojas-virtuais/bianca-faust",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <BiancaFaust />
        </Suspense>
      ),
    },
    {
      path: "/lojas-virtuais/rizzy-collection",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <RizzyCollection />
        </Suspense>
      ),
    },
    {
      path: "/lojas-virtuais/ride-the-beat",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <RideTheBeat />
        </Suspense>
      ),
    },
    {
      path: "/lojas-virtuais/javali-40",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <Javali40 />
        </Suspense>
      ),
    },
    {
      path: "/lojas-virtuais/via-ds-sartoria",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <ViaDsSartoria />
        </Suspense>
      ),
    },
    {
      path: "/lojas-virtuais/duotti",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <Duotti />
        </Suspense>
      ),
    },
    {
      path: "/lojas-virtuais/saint-luce",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <SaintLuce />
        </Suspense>
      ),
    },
  ];
};

export default useRoutersLojas;
